export default __webpack_public_path__ + "static/media/11.2e25e1ff.jpg";